import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import _ from "lodash"

export const am4ScrollbarXMixin = {
    data() {
        return {
            am4ScrollbarX: {
                formatter: null,
            }
        }
    },
    methods: {
        // Setup Scrollbar For X-Axis
        am4SetupScrollbar(chart, isHeavyLoad, formatter) {
            if (this._am4ChartInvalid(chart)) {
                return
            }
            this.am4ScrollbarX.formatter = formatter

            // Remove any current Scrollbars
            if (chart.scrollbarX) {
                let needToDisposeOfOld = isHeavyLoad && chart.scrollbarX instanceof am4charts.XYChartScrollbar
                needToDisposeOfOld = needToDisposeOfOld || !isHeavyLoad && chart.scrollbarX instanceof am4core.Scrollbar
                if (needToDisposeOfOld) {
                    chart.scrollbarX.dispose()
                    chart.scrollbarX = null
                }
            }

            return isHeavyLoad
                    ? this.am4SetupBasicScrollbar(chart)
                    : this.am4SetupPreviewScrollbar(chart, formatter)
        },

        am4SetupBasicScrollbar(chart) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            if (_.isNil(chart.scrollbarX)) {
                chart.scrollbarX = new am4core.Scrollbar()
            }

            return {
                scrollBar: chart.scrollbarX,
                scrollSeries: null,
            }
        },

        am4SetupPreviewScrollbar(chart, formatter = null) {
            if (this._am4ChartInvalid(chart)) {
                return
            }

            formatter = _.isNil(formatter) ? this.am4ScrollbarX.formatter : formatter

            let scrollbarX = null
            let scrollSeries1 = null

            let series = chart.series.getIndex(0)
            try {
                scrollbarX = chart.scrollbarX
                if (_.isNil(scrollbarX)) {
                    scrollbarX = new am4charts.XYChartScrollbar();
                }
                else {
                    scrollbarX.series.clear()
                }

                if (_.isNil(series)) {
                    console.log(`Series is Null.  `)
                    return this.am4SetupBasicScrollbar(chart)
                }

                scrollbarX.series.push(series);
                scrollbarX.scrollbarChart.plotContainer.filters.clear();
                scrollbarX.background.fillOpacity = 1

                scrollSeries1 = scrollbarX.series.getIndex(0);
                scrollSeries1.filters.clear()
                scrollSeries1.minBulletDistance = 10
                scrollSeries1.connect = true
                scrollSeries1.strokeOpacity = 1

                scrollbarX.scrollbarChart.dateFormatter = formatter
                chart.scrollbarX = scrollbarX
            }
            catch (e) {
                console.log(`Error Occurred: `)
                console.log(e)
            }

            return {
                scrollBar: chart.scrollbarX,
                scrollSeries: scrollSeries1,
            }
        },

        _am4ChartInvalid(chart) {
            return _.isNil(chart)
        }
    },
}